export const CONTROL_CARD_APPLICATION_ATTACHMENTS_ROUTE = 'zalaczniki';
export const CONTROL_CARD_APPLICATION_ATTACHMENTS_PARAMETRIZED_ROUTE = ':id/zalaczniki';
